import React, { FC } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import { useRightContentWidth } from '~/hooks/styles';
import { useEditMode, useEditModeStyles } from '~/hooks/useEditModeContext';

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: 'border-box',
    display: 'flex',
    width: ({ width }: any) => width,
    minWidth: ({ width }: any) => width,
    padding: theme.spacing(2),
  },
}));

interface Props {
  width?: number;
  className?: string;
}

const AsideBase: FC<Props> = (props) => {
  const { children, width, className } = props;

  const defaultWidth = useRightContentWidth();
  const resultWidth = width ?? defaultWidth;
  const classes = useStyles({ width: resultWidth });

  const { editMode } = useEditMode();
  const editModeClasses = useEditModeStyles({ editMode });

  return (
    <Paper className={cx(classes.root, editModeClasses.backgroundColor, className)}>
      {children}
    </Paper>
  );
};

export default AsideBase;
